module.exports = __webpack_public_path__ + "media/images/icon__reddit-c4ceb492c42286544c472873bff157da.png";